import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";

export const teachersAdapter = createEntityAdapter();

export const initialState = teachersAdapter.getInitialState({
  chosenTeacher: null,
});

const teachersSlice = createSlice({
  name: "teachers",
  initialState,
  reducers: {
    teachersSetAll: (state, action) => {
      teachersAdapter.setAll(state, action.payload);
    },
    teacherAddOne: (state, action) => {
      teachersAdapter.addOne(state, action.payload);
    },
    teacherUpdateOne: (state, action) => {
      teachersAdapter.updateOne(state, {
        id: action.payload.teacherId,
        changes: {
          teacherName: action.payload.teacherName,
          teacherAndstyles: action.payload.teacherAndstyles,
          teacherAndlevels: action.payload.teacherAndlevels,
          availabilityTime: action.payload.availabilityTime,
          teacherColor: action.payload.teacherColor,
        },
      });
    },
    teacherRemoveOne: (state, action) => {
      teachersAdapter.removeOne(state, action.payload);
    },
    addChosenTeacher: (state, action) => {
      state.chosenTeacher = action.payload;
    },
    removeChosenTeacher: (state, action) => {
      state.chosenTeacher = null;
    },
  },
});

const { actions, reducer } = teachersSlice;
export const {
  teachersSetAll,
  teacherAddOne,
  teacherUpdateOne,
  teacherRemoveOne,
  addChosenTeacher,
  removeChosenTeacher,
} = actions;

export default reducer;
export const { selectAll } = teachersAdapter.getSelectors(
  (state) => state.teachers
);
